export const VESSEL_IDS = ['jar', 'tube', 'petri', 'flask', 'bioreactor'];
/** Колба: узкое горлышко сверху, расширение и широкое дно. */
const FLASK_MASK = [
    '###....###',
    '###....###',
    '###....###',
    '###....###',
    '##......##',
    '##......##',
    '#........#',
    '#........#',
    ...Array(8).fill('..........'),
];
/** Биореактор: две неподвижные перегородки в нижней части делят дно на отсеки. */
const BIOREACTOR_MASK = [
    ...Array(11).fill('........'),
    ...Array(4).fill('..#..#..'),
    ...Array(3).fill('........'),
];
export const VESSELS = Object.freeze({
    jar: { id: 'jar', width: 8, height: 16, spawn: { x: 3, y: 0 }, virusTopRow: 6, mask: null },
    tube: { id: 'tube', width: 6, height: 18, spawn: { x: 2, y: 0 }, virusTopRow: 7, mask: null },
    petri: { id: 'petri', width: 12, height: 10, spawn: { x: 5, y: 0 }, virusTopRow: 4, mask: null },
    flask: {
        id: 'flask',
        width: 10,
        height: 16,
        spawn: { x: 4, y: 0 },
        virusTopRow: 7,
        mask: FLASK_MASK,
    },
    bioreactor: {
        id: 'bioreactor',
        width: 8,
        height: 18,
        spawn: { x: 3, y: 0 },
        virusTopRow: 7,
        mask: BIOREACTOR_MASK,
    },
});
/** Правила поля для сосуда. Остальные правила (вирусы, скорость, босс) задаёт уровень. */
export function vesselRules(id) {
    const v = VESSELS[id];
    return {
        width: v.width,
        height: v.height,
        spawn: v.spawn,
        virusTopRow: v.virusTopRow,
        mask: v.mask,
    };
}
//# sourceMappingURL=vessels.js.map